import { useCallback } from 'react';
import downloadCsv from '@dyl/utils/downloadAssetCsv';

/** @type {import('@dyl/utils/downloadCsv').CsvColumn[]} */
const Columns = [
    { label: 'Task ID', key: 'task_id_name' },
    { label: 'Component ID', key: 'test_names' },
    { label: 'Skill', key: 'skill_id' },
    { label: 'Task Type', key: 'task_type_id' },
    { label: 'Last Modified', key: 'updated_at' },
    { label: 'Anchor', key: 'anchor' },
];
const ColumnsA2 = [
    { label: 'Task ID', key: 'task_id_name' },
    { label: 'Component ID', key: 'test_names' },
    { label: 'Skill', key: 'skill_id' },
    { label: 'Task Type', key: 'task_type_id' },
    { label: 'Last Modified', key: 'updated_at' },
    { label: 'Anchor', key: 'anchor' },
    { label: 'ARC status', key: 'arc_status' },
];

export default function useTasksDownload() {
    return useCallback(
        function downloadTasksCsv(tasks) {
            let columnsToUse = tasks[0].level_id === '200f307f-415d-4bbc-9051-1568d16f96b8' ? ColumnsA2 : Columns;
            const fileName = `Tasks_${new Date().toDateString()}.csv`;

            downloadCsv(fileName, columnsToUse, tasks);
        }, []
    );
}